import styled from "styled-components";
import SubTotals from "../admin/Orders/OrderLineItem/SubTotals";
import { Button } from "react-bootstrap";
import BasketItem from "./basketItem";
import { TableActionButtonDelete } from "../../@ui/TableActionButtonDelete";
import { useNavigate } from "react-router-dom";
import { useBasketContext } from "../../context/Basket/BasketContext";
import { useTenantContext } from "../../context/Tenant/TenantContext";
import useBasketService from "../../hooks/useBasketService";
import { useEffect, useState } from "react";

const Container = styled.div`
  height: 100vh;
`;

const Content = styled.div`
  height: calc(100vh - 67.25px);
  padding: 5rem 10rem 5rem 10rem;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 5px;
`;

const ItemsContainer = styled.div`
  & > *:last-child {
    border-bottom: 1px solid #ccc;
  }
`;

const Basket = () => {
  const { basket, setBasket } = useBasketContext();
  const { config } = useTenantContext();
  const basketService = useBasketService();
  const navigate = useNavigate();
  const [acceptedEULA, setAcceptedEULA] = useState(false);
  const [overMaxCheckout, setOverMaxCheckout] = useState(false);

  useEffect(() => {
    setOverMaxCheckout((basket?.totalIncTax ?? 0) >= 1000000);
  }, [basket]);

  const removeItem = async (id: string) => {
    try {
      const newBasket = await basketService.RemoveFromBasket(id);
      setBasket(newBasket);
      if (newBasket == null || newBasket.lineItems.length === 0) {
        navigate("/");
      }
    } catch (e) {
      navigate("/");
    }
  };

  const emptyBasket = async () => {
    try {
      const newBasket = await basketService.EmptyBasket();
      setBasket(newBasket);
    } finally {
      navigate("/");
    }
  };

  const checkout = async () => {
    const url = await basketService.ConfirmOrder();
    window.location.href = url;
  };

  const openEULA = async () => {
    const url = await basketService.GetEULA();
    if (url) window.open(url, "_blank");
  };

  const name = config.name === "Default" ? "Datacutter" : config.name;

  return (
    <Container className="card-theme text-white">
      <Content className="d-flex flex-row w-100">
        <div
          style={{
            width: "80%",
          }}
          className="p-2"
        >
          <Card className="p-3 h-100 overflow-auto bg-light">
            <div className="d-flex flex-row justify-content-between align-items-end mb-2 text-black">
              <h4 className="mb-0 text-black">Basket</h4>
              <p className="mb-0 text-black">Price</p>
            </div>
            {basket && (
              <ItemsContainer>
                {basket.lineItems.map((item) => (
                  <BasketItem
                    key={item.id}
                    removeItem={removeItem}
                    item={item}
                  />
                ))}
              </ItemsContainer>
            )}
            <TableActionButtonDelete
              onClick={() => emptyBasket()}
              className="mt-2"
            >
              Empty Basket
            </TableActionButtonDelete>
            {basket && basket.lineItems.length > 0 && (
              <>
              <div className="mt-2 mb-0 text-danger">
                {basket.lineItems.some((item) => item.layerName === "Inrix:Trip") && (
                    <span>Once payment is complete, your data will be prepared and delivered within a few hours.</span>
                  )}
              </div>
              <div className="mt-1 text-black">
                <label>
                  <input
                    type="checkbox"
                    checked={acceptedEULA}
                    onChange={(e) => setAcceptedEULA(e.target.checked)}
                  />{" "}
                  I have read and accept the{" "}
                  <Button
                    variant="link"
                    onClick={() => openEULA()}
                    className="px-0"
                  >
                    {name} Data End User Licence Agreement
                  </Button> 
                </label>
              </div>
              </>
            )}
          </Card>
        </div>
        <div style={{ width: "20%" }} className="p-2 h-100">
          <Card className="px-2 py-2 d-flex flex-column gap-2 bg-light text-black">
            {" "}
            {basket && (
              <SubTotals
                transactionCurrencyCode={basket!.transactionCurrencyCode}
                totalExTax={basket!.totalExTax}
                totalTax={basket!.totalTax}
                totalIncTax={basket!.totalIncTax}
              />
            )}
            <Button
              onClick={() => checkout()}
              disabled={!acceptedEULA || overMaxCheckout}
            >
              Checkout
            </Button>
            {overMaxCheckout && (
              <p className="text-danger small mb-0">
                Basket total exceeds maximum allowed checkout amount of
                1,000,000.
                <br />
                <br />
                Please contact{" "}
                <a href={`mailto:${config.salesEmail}`}>{config.salesEmail}</a>.
              </p>
            )}
          </Card>
        </div>
      </Content>
    </Container>
  );
};

export default Basket;
